import { TokenCredentials } from '../login/tokencredentials';

export class Area {
    credentials: TokenCredentials;

    id: number;
    userid: number;
    name: string;
    shortname: string;
    prefix: string;
    barcodeformat: string;
    created: Date;
    updated: Date;
}

export class AreaBarcodeFormat {
    barcodeformat: string;
    area: boolean = false;
    l_area: number = 0;
    p_area: string = 'A';
    rack: boolean = false;
    l_rack: number = 0;
    p_rack: string = 'R';
    tray: boolean = false;
    l_tray: number = 0;
    p_tray: string = 'T';
    level: boolean = false;
    l_level: number = 0;
    p_level: string = 'L';
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/area.ts